module.exports = __webpack_public_path__ + "img/usericon.7859245f.jpg";